import React from "react";
import { Col, Row, Spinner } from "reactstrap"; // Reactstrap components

const ProfileInfoLoader = () => {
  return (
    <>
      <Row className="mt-4">
        {[1, 2, 3].map((_, index) => (
          <Col xs={12} md={6} lg={4} key={index}>
            <div
              style={{
                height: "270px",
                display: "flex",
                justifyContent: "stretch",
                overflow: "hidden",
                borderRadius: "10px",
                border: "1px solid #CABAAD",
              }}
            >
              <div
                style={{
                  flex: 3,
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    borderRadius: "20px",
                    backgroundColor: "#f1f1f1",
                    width: "100%",
                    height: "500px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Spinner
                    style={{
                      width: "3rem",
                      height: "3rem",
                    }}
                    color="primary"
                  />
                </div>
              </div>
              <div
                style={{
                  flex: 1,
                  padding: "16px",
                  display: "flex",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                }}
              >
                {[...Array(8)].map((_, i) => (
                  <div
                    key={i}
                    style={{
                      height: "50px",
                      width: "50px",
                      backgroundColor: "#f1f1f1",
                      // borderRadius: "50%",
                      marginBottom: "8px",
                    }}
                  >
                  </div>
                ))}
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </>
  );
};

export default ProfileInfoLoader;
